// extracted by mini-css-extract-plugin
export var aircallIframe = "_hw-3";
export var fabContainer = "_hw-5";
export var fabRinging = "_hw-6";
export var loadingOverlay = "_hw-4";
export var pulse = "_hw-7";
export var widgetContent = "_hw-2";
export var widgetPanel = "_hw-0";
export var widgetPanelExpanded = "_hw-1";